var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-6"},[_c('field-label',{attrs:{"field":_vm.field}}),_c('v-btn-toggle',{staticClass:"d-block",attrs:{"group":"","value":_vm.value,"mandatory":""},on:{"change":_vm.input}},_vm._l((_vm.colors),function(option){return _c('v-btn',{key:option.value,attrs:{"small":"","value":option.value}},[(option.value != 'inherit')?_c('div',{staticClass:"elevation-2 mr-2",style:({
          backgroundColor: option.value,
          width: '20px',
          height: '10px'
        })}):_vm._e(),_vm._v("\n      "+_vm._s(option.text)+"\n    ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }